import { getAPICall, getAPICallWithParams, postAPICall, baseGetAPICall } from './BaseAPI';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API_URL } from '../common/constants/AppConstants';
import { LLC_MASTER_KEY } from '../../env';

// ── Tenant-facing ──────────────────────────────────────────────

export const getLLCPublicKey = async (cb = (jR, s, e) => {}) => {
  return await getAPICall('llc-billing/public-key', cb);
};

export const createLLCSetupIntent = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('llc-billing/setup-intent', payload, cb);
};

export const saveLLCBillingCard = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('llc-billing/save-card', payload, cb);
};

export const getTenantBillingStatus = async (cb = (jR, s, e) => {}) => {
  return await getAPICall('llc-billing/tenant-status', cb);
};

export const toggleBillingEnabled = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('llc-billing/toggle-billing', payload, cb);
};

export const getUnbilledOrders = async (params: any = {}, cb = (jR, s, e) => {}) => {
  return await getAPICallWithParams('llc-billing/unbilled-orders', params, cb);
};

export const tenantTriggerCharge = async (cb = (jR, s, e) => {}) => {
  return await postAPICall('llc-billing/charge-now', {}, cb);
};

export const updateTenantSettings = async (payload: any, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const response = await fetch(`${API_URL}/llc-billing/tenant-settings`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
  const json = await response.json();
  cb(json, response.status, null);
  return response;
};

// ── LLC Master Admin (requires x-llc-master-key header) ───────

const masterHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'x-llc-master-key': LLC_MASTER_KEY,
  };
};

export const getBillingOverview = async (params: any = {}, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const queryString = new URLSearchParams(params).toString();
  const route = queryString ? `llc-billing/admin/billing-overview?${queryString}` : 'llc-billing/admin/billing-overview';
  return await baseGetAPICall(route, { ...masterHeaders(), Authorization: `Bearer ${token}` }, cb);
};

export const getOrderDetail = async (serverName: string, params: any = {}, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const queryString = new URLSearchParams(params).toString();
  const route = queryString
    ? `llc-billing/admin/order-detail/${serverName}?${queryString}`
    : `llc-billing/admin/order-detail/${serverName}`;
  return await baseGetAPICall(route, { ...masterHeaders(), Authorization: `Bearer ${token}` }, cb);
};

export const getLLCNotifications = async (params: any = {}, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const queryString = new URLSearchParams(params).toString();
  const route = queryString ? `llc-billing/admin/notifications?${queryString}` : 'llc-billing/admin/notifications';
  return await baseGetAPICall(route, { ...masterHeaders(), Authorization: `Bearer ${token}` }, cb);
};

export const triggerManualCharge = async (serverName: string, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const response = await fetch(`${API_URL}/llc-billing/admin/trigger-charge/${serverName}`, {
    method: 'POST',
    headers: { ...masterHeaders(), Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  cb(json, response.status, null);
  return response;
};

export const updateBillingSettings = async (serverName: string, payload: any, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const response = await fetch(`${API_URL}/llc-billing/admin/billing-settings/${serverName}`, {
    method: 'PATCH',
    headers: { ...masterHeaders(), Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
  const json = await response.json();
  cb(json, response.status, null);
  return response;
};

export const getTenantBrands = async (serverName: string, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  return await baseGetAPICall(`llc-billing/admin/tenant-brands/${serverName}`, { ...masterHeaders(), Authorization: `Bearer ${token}` }, cb);
};

export const updateTenantBrandFees = async (serverName: string, payload: any, cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const response = await fetch(`${API_URL}/llc-billing/admin/tenant-brand-fees/${serverName}`, {
    method: 'PATCH',
    headers: { ...masterHeaders(), Authorization: `Bearer ${token}` },
    body: JSON.stringify(payload),
  });
  const json = await response.json();
  cb(json, response.status, null);
  return response;
};

export const getCronLogs = async (cb = (jR, s, e) => {}) => {
  const token = await AsyncStorage.getItem('access-token');
  const response = await fetch(`${API_URL}/llc-billing/admin/cron-logs`, {
    headers: { ...masterHeaders(), Authorization: `Bearer ${token}` },
  });
  const json = await response.json();
  cb(json, response.status, null);
  return response;
};
